export enum HealthGuideServicesTypeEnum {
	EMERGENCY = 'PRONTO SOCORRO URGEN/EMERGEN',
	OUTPATIENT = 'CONSULTORIOS/CLINICAS',
	ELECTIVE_HOSPITAL = 'HOSPITAL ELETIVO',
	AUXILIARY_SERVICES = 'SERVICOS AUXILIARES DE DIAGNOSTICO E TERAPIA',
	MATERNITY = 'MATERNIDADE',
}
